export const urls = {
    italianStories: "/italian-stories",
    contatcts: "/contacts",
    login: "/login",
    userProfile: "/user-page",
    home: "/",
};
